module.exports = __webpack_public_path__ + "img/bgc.03c9a6cc.png";